export const config = {
  v1: {
    searchResultDescription: 'If you\'re booking a virtual appointment, you can book at any shop or select one nearer to you.',
  },
};
